import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  PaginationParams,
  PickActions,
} from '@core/ngrx-legacy';
import type { TemplateAssignedOffer } from '@core/workflow-templates-types';

const { actions, reducer, selectors, namespace } =
  createEntityCollectionStore<TemplateAssignedOffer>()('TemplateAssignedJobTemplate', {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, ({ id }: { id: number }) => id);
      return {
        fetchPaginatedCollection: (
          state,
          payload: { scope: string; params: PaginationParams & { q: string | null; id: number } },
        ) => defaultActions.fetchPaginatedCollection(state, payload),
      };
    },
  });

const TemplateAssignedJobTemplateActions: PickActions<typeof actions, 'fetchPaginatedCollection'> =
  actions;

export {
  TemplateAssignedJobTemplateActions,
  reducer as TemplateAssignedJobTemplateReducer,
  selectors as TemplateAssignedJobTemplateSelectors,
  namespace as TemplateAssignedJobTemplateNamespace,
};
